import { useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";
import { api } from "@/lib/api";
import { DEFAULT_CONTENT } from "@/lib/defaults";
import Preloader from "@/components/Preloader";
import Navbar from "@/sections/Navbar";
import Hero from "@/sections/Hero";
import EditorialMarquee from "@/sections/Marquee";
import About from "@/sections/About";
import Services from "@/sections/Services";
import Packages from "@/sections/Packages";
import AppPlans from "@/sections/AppPlans";
import Portfolio from "@/sections/Portfolio";
import Maintenance from "@/sections/Maintenance";
import Process from "@/sections/Process";
import Testimonials from "@/sections/Testimonials";
import FAQ from "@/sections/FAQ";
import Contact from "@/sections/Contact";
import Footer from "@/sections/Footer";

export default function Home() {
  const [content, setContent] = useState(DEFAULT_CONTENT);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/content")
      .then((r) => setContent((prev) => ({ ...prev, ...r.data })))
      .catch(() => {});
    const t = setTimeout(() => setLoading(false), 2300);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="relative min-h-screen bg-[#050811] text-white" data-testid="home-page">
      <AnimatePresence>{loading && <Preloader />}</AnimatePresence>
      <div className="noise-layer" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero site={content.site} start={!loading} />
        <EditorialMarquee />
        <About site={content.site} />
        <Services />
        <Packages packages={content.packages} />
        <AppPlans plans={content.app_plans} />
        <Portfolio items={content.portfolio} />
        <Maintenance plans={content.maintenance_plans} appPlans={content.app_care_plans} />
        <Process />
        <Testimonials />
        <FAQ />
        <Contact contact={content.contact} formOptions={content.form_options} />
      </main>
      <Footer contact={content.contact} />
    </div>
  );
}
